import { getMatches, getInitialMatches, getLeagues, postUserPred, getUserPicks, deleteUserPicks } from "../api/";
import { mockLeagues, mockMatches, mockPicks } from "./mockData";

// REACT_APP_USE_MOCK=true serves built-in sample data instead of the API (for working on the UI
// without server-copa). Off unless set explicitly.
const useMock = process.env.REACT_APP_USE_MOCK === 'true';
const mockPickStore = useMock ? mockPicks() : [];

export const MatchService = {
  // Every call returns a promise that rejects when the API fails, so pages can show an error.
  getMatchesOnLoad(areaInfo, leagueInfo, dateInfo) {
    if (useMock) {
      const rows = mockMatches(dateInfo);
      return Promise.resolve(areaInfo && leagueInfo
        ? rows.filter((m) => m.Country === areaInfo && m.League === leagueInfo) : rows);
    }
    if (dateInfo) {
      return getInitialMatches({ dateInfo });
    }
    if (areaInfo && leagueInfo) {
      return getMatches({ leagueInfo, areaInfo });
    }
    return getInitialMatches({});
  },

  // Upcoming matches of several leagues ("area/league" keys), fetched in parallel and merged.
  getMatchesForLeagues(keys) {
    return Promise.all(keys.map((key) => {
      const [area, league] = key.split('/');
      return this.getMatchesOnLoad(area, league);
    })).then((lists) => {
      const seen = new Set();
      return lists.flat().filter((row) => {
        const id = row.PredId ?? `${row.HomeTeamCode}|${row.AwayTeamCode}|${row.MatchTime}`;
        if (seen.has(id)) {
          return false;
        }
        seen.add(id);
        return true;
      });
    });
  },

  // server-copa's getLeagues answers with lowercase keys (area, league); the panel uses Area/League.
  getLeagues() {
    return (useMock ? Promise.resolve(mockLeagues) : getLeagues()).then((rows) => (Array.isArray(rows) ? rows : [])
      .map((row) => ({ ...row, Area: row.Area ?? row.area, League: row.League ?? row.league }))
      .filter((row) => row.Area && row.League));
  },

  submitUserPred(userPred) {
    if (useMock) {
      if (userPred.PredId === -1) {
        mockPickStore.push({ ...userPred, PredId: Date.now() });
      }
      return Promise.resolve();
    }
    return postUserPred(userPred);
  },

  getUserPicks(userCookie) {
    return useMock ? Promise.resolve(mockPickStore.map((p) => ({ ...p }))) : getUserPicks(userCookie);
  },

  deleteUserPicks(userCookie, matchesToDelete) {
    if (useMock) {
      const ids = matchesToDelete.map((m) => m.PredId);
      mockPickStore.splice(0, mockPickStore.length, ...mockPickStore.filter((p) => !ids.includes(p.PredId)));
      return Promise.resolve();
    }
    return deleteUserPicks(userCookie, matchesToDelete);
  },
};
